import type { Community } from '@communities/community/domain';
import { CommunityGrid } from '@communities/community-groups/components';
import { CommunityGroupHeader } from '@communities/community-groups/components/CommunityGroupHeader';
import type { CommunityGroup } from '@communities/community-groups/domain';
import { SectionHeader } from '@core/components';
import { withAppInsightsTracking } from '@core/logging/withAppInsightsTracking';
import { Section } from '@soteria/design-system-ve';

import * as styles from './CommunityGroupHeaderSection.css';

interface CommunityGroupHeaderSectionProps {
  communityGroup: CommunityGroup;
  communitiesCount: number;
  communities: Community[] | null;
  isCommunityGroupAdmin: boolean;
  onAddCommunity: () => void;
  onDeleteGroup: () => void;
  onSelectCommunity: (community: Community) => void;
}

/**
 * Header section component with gradient transition
 * Contains community group name, description, and communities grid
 * Background image is handled by the global HeroBackground component
 */
function CommunityGroupHeaderSectionComponent({
  communityGroup,
  communitiesCount,
  communities,
  isCommunityGroupAdmin,
  onAddCommunity,
  onDeleteGroup,
  onSelectCommunity,
}: CommunityGroupHeaderSectionProps) {
  return (
    <div className={styles.heroSection}>
      {/* Gradient Overlay */}
      <div className={styles.heroOverlay} />

      <div className={styles.heroContent}>
        {/* Community Group Header */}
        <CommunityGroupHeader
          communitiesCount={communitiesCount}
          description={communityGroup.description || ''}
          isCommunityGroupAdmin={isCommunityGroupAdmin}
          name={communityGroup.name}
          onAddCommunity={onAddCommunity}
          onDeleteGroup={onDeleteGroup}
        />

        {/* Communities Section */}
        <Section className={styles.communitiesSection} spacing="none">
          <SectionHeader description="Communities in this group." title="Communities" />
          <div className={styles.communityGridStyle}>
            <CommunityGrid
              columnFit="auto-fill"
              communities={communities || []}
              emptyStateClassName={styles.emptyCommunitiesStateStyle}
              onSelectCommunity={onSelectCommunity}
            />
          </div>
        </Section>
      </div>
    </div>
  );
}

export const CommunityGroupHeaderSection = withAppInsightsTracking(CommunityGroupHeaderSectionComponent, 'CommunityGroupHeaderSection');
